import { useLocation, useNavigate } from "react-router-dom";

import { Avatar } from "../../Atomics/Avatar";
import Box from "../../Atomics/Box"
import { StyledButton } from "../../Atomics/Button"
import { Heading } from "../../Atomics/Heading";
import { Paragraph } from "../../Atomics/Paragraph";
import CustomIcon from "../../Icons/CustomIcon";

import { TSerializedIncident } from "../../../../api/types";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { useTranslationContext } from "../../../../contexts/TranslationContext";
import { statusMapping } from "../../../../utils/helpers/statusMapping";

type TProps = TSerializedIncident;

const IncidentCard = ({ icon, incidentId, categoryTitle, incidentTitle, incidentDescription, lat, lng, section, statusLevel, date, watchListId, openedBy, callerId }: TProps) => {
    const { user } = useAuthContext();
    const { translate, resources } = useTranslationContext();
    const navigate = useNavigate();
    const location = useLocation();
    const status = statusMapping(statusLevel);

    const stateBody = {
        icon,
        categoryTitle,
        incidentId,
        incidentTitle,
        incidentDescription,
        lat,
        lng,
        section,
        statusLevel,
        date,
        watchListId,
        openedBy,
        callerId,
    }

    // My Incident Label
    // Display label "Nos meus incidentes" when the incident was created by the user or it's in his watch list. Also hide it on profile page cards.
    const displayLabelMyIncident = ((user?.sys_id === openedBy) || (user?.sys_id === watchListId)) && location.pathname !== '/profile';

    return (
        <StyledButton width="100%" height="100%" py="sm" my="xs" onClick={() => navigate('/detail', { state: stateBody })}>
            <Box display="flex" justifyContent="space-between" width="100%" height="100%" bg="white" boxShadow="level2" borderRadius="lg" p="md">

                {/* LEFT SIDE */}
                <Box display="flex" flexDirection="column" alignItems="start" flex="1 1 0">
                    {icon ? <CustomIcon icon={icon} customColor="black-1" /> : <CustomIcon icon="PageNotFound" width={70} height={50} />}
                    <Heading level={1} typography="text-s-bold" customColor="black-1" textAlign='left' mt={icon ? 'md' : undefined} width="70%">
                        {translate(categoryTitle) ?? categoryTitle}
                    </Heading>
                </Box>

                {/* RIGHT SIDE */}
                <Box display="flex" flexDirection="column" alignItems="start" justifyContent="space-between" ml="md" width="100%" flex="1 1 0">
                    {displayLabelMyIncident && <Box typography="ui-xxs-semibold" bg="black-1" customColor="white" py="xs" px="sm">{resources.label.inMyIncidents}</Box>}
                    <Box display="flex" flexDirection="column" alignItems="start">
                        <Heading level={1} typography="text-s-bold" textAlign="left">{incidentTitle}</Heading>
                        <Heading level={2} typography="text-s-bold" textAlign="left" customColor="coolgray-7">Secção {section}</Heading>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <Avatar position="relative" bg={status?.iconColor} size={11} />
                        <Paragraph typography="text-xs-regular" customColor="coolgray-10" ml="sm">{status && (status?.name)}</Paragraph>
                    </Box>
                </Box>
            </Box>
        </StyledButton>
    )
}

export default IncidentCard